// Port of api/fuel/app/classes/insights/game/attribute.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'attribute',
    priority: 1,
    default_: false,
    requires: ['init'],
    insight: false,
    detail: ['attribute'],
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)
        var attrType = vars.attrType || false
        var attrId = vars.attrId ? parseInt(vars.attrId, 10) : 0

        if (!attrType || !attrId) return {}

        var tables = {
            designer: { join: 'game_designer', col: 'designer_id', name_col: 'designer_name' },
            publisher: { join: 'game_publisher', col: 'publisher_id', name_col: 'publisher_name' },
            mechanic: { join: 'game_mechanic', col: 'mechanic_id', name_col: 'mechanic_name' },
            category: { join: 'game_category', col: 'category_id', name_col: 'category_name' }
        }

        if (!tables[attrType]) return {}

        var cfg = tables[attrType]
        var extra = (attrType === 'publisher') ? ' AND l.game_publisher_primary = 1 AND l.game_version_id = 0' : ''

        // Get attribute name
        var nameRow = Util.queryFast('SELECT ' + cfg.name_col + ' AS name FROM ' + attrType + ' WHERE ' + cfg.col + ' = ' + attrId)
        var attrName = nameRow.length ? nameRow[0].name : 'Unknown'

        // Use Init's shared universe
        var universeIds = this._data.universe_ids
        if (!universeIds.length) return { attribute: { name: attrName, type: attrType, games: [] } }

        // All universe games with this attribute (base games only)
        var gameRows = Util.queryFast(
            'SELECT DISTINCT l.game_id, g.game_name FROM ' + cfg.join + ' l ' +
            'JOIN game g ON g.game_id = l.game_id ' +
            'WHERE l.' + cfg.col + ' = ' + attrId +
            ' AND g.game_type = ' + Constants.GAME_TYPE_BASE +
            ' AND l.game_id IN(' + Util.in(universeIds) + ')' + extra +
            ' ORDER BY g.game_name ASC'
        )

        var gameIds = Util.pluck(gameRows, 'game_id')
        if (!gameIds.length) return { attribute: { name: attrName, type: attrType, games: [] } }

        var gameIn = Util.in(gameIds)

        // Ratings
        var ratings = Util.queryFast('SELECT game_id, rating_value AS rating FROM rating WHERE user_id = ' + user_id + ' AND game_id IN(' + gameIn + ') AND rating_value > 0')
        var ratingMap = {}
        for (var ri = 0; ri < ratings.length; ri++) ratingMap[parseInt(ratings[ri].game_id, 10)] = parseFloat(ratings[ri].rating)

        // Plays
        var plays = Util.queryFast('SELECT game_id, SUM(play_count) AS plays FROM play WHERE user_id = ' + user_id + ' AND game_id IN(' + gameIn + ') GROUP BY game_id')
        var playMap = {}
        for (var pi = 0; pi < plays.length; pi++) playMap[parseInt(plays[pi].game_id, 10)] = parseInt(plays[pi].plays, 10)

        // Ownership duration from status logs
        var ownershipRows = Util.queryFast(
            'SELECT game_id, log_context, log_date FROM log_user_collection_status ' +
            'WHERE user_id = ' + user_id + ' AND log_status = ' + Constants.COLLECTION_STATUS_OWN +
            ' AND game_id IN(' + gameIn + ') ORDER BY game_id, log_date ASC'
        )

        var ownershipEvents = {}
        for (var oi = 0; oi < ownershipRows.length; oi++) {
            var gid = parseInt(ownershipRows[oi].game_id, 10)
            if (!ownershipEvents[gid]) ownershipEvents[gid] = []
            ownershipEvents[gid].push({ context: parseInt(ownershipRows[oi].log_context, 10), date: parseInt(ownershipRows[oi].log_date, 10) })
        }

        // Collection status flags
        var collectionRows = Util.queryFast(
            'SELECT game_id, collection_own, collection_prevowned, collection_wishlist FROM collection ' +
            'WHERE user_id = ' + user_id + ' AND game_id IN(' + gameIn + ')'
        )

        var currentlyOwned = {}
        var prevOwned = {}
        var wishlisted = {}

        for (var ci = 0; ci < collectionRows.length; ci++) {
            var cr = collectionRows[ci]
            if (parseInt(cr.collection_own, 10)) currentlyOwned[parseInt(cr.game_id, 10)] = true
            if (parseInt(cr.collection_prevowned, 10)) prevOwned[parseInt(cr.game_id, 10)] = true
            if (parseInt(cr.collection_wishlist, 10)) wishlisted[parseInt(cr.game_id, 10)] = true
        }

        var now = Util.time()
        var durationMap = {}

        var oeKeys = Object.keys(ownershipEvents)
        for (var oei = 0; oei < oeKeys.length; oei++) {
            var oeGid = parseInt(oeKeys[oei], 10)
            var events = ownershipEvents[oeGid]
            var totalDays = 0
            var addDate = null

            for (var ei = 0; ei < events.length; ei++) {
                if (events[ei].context === Constants.LOG_CONTEXT_ADDED) {
                    addDate = events[ei].date
                } else if (events[ei].context === Constants.LOG_CONTEXT_REMOVED && addDate !== null) {
                    totalDays += Math.max(1, Math.ceil((events[ei].date - addDate) / Constants.TIME_DAY))
                    addDate = null
                }
            }

            if (addDate !== null && currentlyOwned[oeGid]) {
                totalDays += Math.max(1, Math.ceil((now - addDate) / Constants.TIME_DAY))
            }

            if (totalDays > 0) durationMap[oeGid] = totalDays
        }

        // Build game list
        var games = []

        for (var gi = 0; gi < gameIds.length; gi++) {
            var gid2 = parseInt(gameIds[gi], 10)

            this._references.games.push(gid2)

            games.push({
                id: gid2,
                rating: ratingMap[gid2] !== undefined ? ratingMap[gid2] : 0,
                plays: playMap[gid2] !== undefined ? playMap[gid2] : 0,
                duration: durationMap[gid2] !== undefined ? durationMap[gid2] : null,
                owned: !!currentlyOwned[gid2],
                prevowned: !!prevOwned[gid2],
                wishlisted: !!wishlisted[gid2],
                rated: ratingMap[gid2] !== undefined,
                played: playMap[gid2] !== undefined,
                isThis: (gid2 === game_id)
            })
        }

        return {
            attribute: {
                name: attrName,
                type: attrType,
                games: games
            }
        }

    }
})
